/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import { colorAt } from 'solis/theme/palette';


export default class BoardUser extends Logic
{
  constructor (board, user)
  {
    super(board);

    this.user = user;
  }


  getName ()
  {
    return this.getAccountView().cass.name;
  }


  getColor ()
  {
    return colorAt(this.getAccountView().cass.theme);
  }


  getAccountView ()
  {
    return this.object.getAccountView(this.user);
  }


};
